import { interpolate } from "gsap/all";
import Commons from "oc-commons/Commons";

export default class Partslist {
  constructor(arrangement) {
    this.basicTotal = 0.0;
    this.additionalTotal = 0.0;
    this.total = 0.0;
    this.vat = APP.settings.vat || 5.0;
    this.parts = [];
    this.arrangement = arrangement;
  }

  update() {
    const parts = [];

    //BasicEQ
    if (this.arrangement.state.selectedComb?.Article) {
      const article = APP.richMetadata.metadata.Artikel.find(
        (art) => art.id === this.arrangement.state.selectedComb?.Article.id
      );
      parts.push({
        type: "BasicEquipment",
        title: article.Artikeltext,
        price: article.Preis,
        basePrice: article.Preis,
        amount: 1,
        ean: article.EAN,
      });
    }
    this.arrangement.state.selectedColors?.forEach((color) => {
      const article = APP.richMetadata.metadata.Artikel.find((a) => a.Artikelnummer === color.articleId);
      if (article) {
        parts.push({
          type: "BasicEquipment",
          title: article.Artikeltext,
          basePrice: article.Preis,
          price: article.Preis,
          amount: 1,
          ean: article.EAN,
        });
      }
    });
    if (this.arrangement.booth?.basicInteriors) {
      const unsortedInteriors = this.arrangement.booth?.basicInteriors;
      unsortedInteriors.forEach((interior) => {
        const inter = APP.richMetadata.metadata.Artikel.find(
          (art) => art.id === interior.article.id
        );
        parts.push({
          type: "BasicEquipment",
          title: inter.Artikeltext,
          basePrice: inter.Preis,
          price: inter.Preis,
          amount: 1,
          ean: inter.EAN,
        });
      });
    }
    if (this.arrangement.booth?.basicExtras) {
      const extras = this.arrangement.booth?.basicExtras;
      extras.forEach((extra) => {
        const inter = APP.richMetadata.metadata.Artikel.find((art) => art.Artikelnummer === extra.Artikelnummer);
        parts.push({
          type: "BasicEquipment",
          title: inter.Artikeltext,
          basePrice: inter.Preis,
          price: inter.Preis,
          amount: extra.amount,
          ean: inter.EAN,
        });
      });
    }

    //AdditionalEQ
    if (this.arrangement.booth?.interiors) {
      // Artikel die hier sind und nicht in basicEQ müssen hinzugefügt werden
      // Artikel die hier sind und öfter als in basicEQ sind müssen hinzugefügt werden (so oft)
      // InteriorArticles - basicArticles
      const interiorArticles = this.arrangement.booth?.interiors.map((interior) => {
        return APP.richMetadata.metadata.Artikel.find((art) => art.Artikelnummer === interior.article.Artikelnummer);
      });
      const diffArticles = [...interiorArticles];
      this.arrangement.booth?.basicInteriorArticles?.forEach((basicIntArticle) => {
        const index = diffArticles.findIndex(a => a.Artikelnummer == basicIntArticle.Artikelnummer);
        if (index > -1) {
          diffArticles.splice(index, 1);
        }
      });

      diffArticles.forEach((article) => {
        parts.push({
          type: "AdditionalEquipment",
          title: article.Artikeltext,
          basePrice: article.Preis,
          price: article.Preis,
          amount: 1,
          ean: article.EAN,
        });
      });
    }
    if (this.arrangement.booth?.extras) {
      const extraArticles = this.arrangement.booth?.extras
        .map((extra) => {
          return [...Array(extra.amount).keys()].map(() => {
            return {
              ...APP.richMetadata.metadata.Artikel.find((art) => art.id === extra.id),
              amount: 1,
            };
          });
        })
        .flat();
      const diffExtras = [...extraArticles];
      this.arrangement.booth?.basicExtraArticles?.forEach((basicExtraArticle) => {
        const innerExtraArticles = this.arrangement.booth?.basicExtraArticles
          .map((extra) => {
            return [...Array(extra.amount).keys()].map(() => {
              return {
                ...APP.richMetadata.metadata.Artikel.find((art) => art.id === extra.id),
                amount: 1,
              };
            });
          })
          .flat();
        innerExtraArticles.forEach((InnerBasicExtraArticle) => {
          const index = diffExtras.findIndex((article) => article.id == InnerBasicExtraArticle.id);
          if (index > -1) {
            diffExtras.splice(index, 1);
          }
        });
      });

      diffExtras.forEach((article) => {
        parts.push({
          type: "AdditionalEquipment",
          title: article.Artikeltext,
          basePrice: article.Preis,
          price: article.Preis,
          amount: 1,
          ean: article.EAN,
        });
      });
    }

    // Group parts

    const groupedParts = [];
    parts.forEach((part) => {
      const groupedPart = groupedParts.find(
        (gPart) => gPart.type == part.type && gPart.title == part.title && gPart.EAN == part.EAN
      );
      if (groupedPart) {
        groupedPart.amount += 1;
        groupedPart.price = groupedPart.amount * groupedPart.basePrice;
      } else {
        groupedParts.push(part);
      }
    });

    this.parts = groupedParts;
    this.basicTotal = this.parts
      .filter((part) => part.type == "BasicEquipment")
      .map((p) => p.price)
      .reduce((prevPart, currPart) => {
        return prevPart + currPart;
      }, 0);

    this.additionalTotal = this.parts
      .filter((part) => part.type == "AdditionalEquipment")
      .map((p) => p.price)
      .reduce((prevPart, currPart) => {
        return prevPart + currPart;
      }, 0);

    this.subtotal = this.basicTotal + this.additionalTotal;
    this.vatTotal = this.subtotal * (this.vat / 100);
    this.total = this.subtotal * (1 + this.vat / 100);
  }

  toJSON() {
    const clone = Commons.cloneDeep(this);
    delete clone.arrangement;
    return clone;
  }
}
